export enum PlantExternalIdType {
  Consignee = 'CONSIGNEE',
  Delivery = 'DELIVERY',
}
